import { alpha } from "@mui/material/styles";

// ----------------------------------------------------------------------

export default function Input(theme) {
	return {
		MuiInputBase: {
			styleOverrides: {
				root: {
					borderColor: "1px solid #D0D5DD",
					backgroundColor: theme.palette.grey[0],
					borderRadius: "10px !important",
					"&.Mui-disabled": {
						"& svg": { color: theme.palette.text.disabled },
					},
					"&.Mui-focused": {
						borderColor: "#D0D5DD",
					},
					".MuiInputBase-input": {
						color: theme.palette.secondary.main,
						fontSize: 16,
						fontWeight: 400,
						lineHeight: 1.5,
						padding: "15px 14px",
						"&::placeholder": {
							opacity: 1,
							color: theme.palette.grey[600],
						},
					},
				},
			},
		},
		MuiInput: {
			styleOverrides: {
				underline: {
					"&:before": {
						borderBottomColor: alpha(theme.palette.grey[500], 0.56),
					},
				},
			},
		},
		MuiFilledInput: {
			styleOverrides: {
				root: {
					backgroundColor: alpha(theme.palette.grey[500], 0.12),
					"&:hover": {
						backgroundColor: alpha(theme.palette.grey[500], 0.16),
					},
					"&.Mui-focused": {
						backgroundColor: theme.palette.action.focus,
					},
					"&.Mui-disabled": {
						backgroundColor:
							theme.palette.action.disabledBackground,
					},
				},
				underline: {
					"&:before": {
						borderBottomColor: alpha(theme.palette.grey[500], 0.56),
					},
				},
			},
		},
		MuiOutlinedInput: {
			styleOverrides: {
				root: {
					"& .MuiOutlinedInput-notchedOutline": {
						borderColor: alpha(theme.palette.grey[500], 0.32),
					},
					"&.Mui-disabled": {
						"& .MuiOutlinedInput-notchedOutline": {
							borderColor:
								theme.palette.action.disabledBackground,
						},
					},
				},
			},
		},
	};
}
